import * as queries from './queries';

export const plants = {
  queries: {
    ...queries
  }
};
